import { graphql } from 'react-relay';
import { ConfluencePageAri } from '@atlassian/ari';

import { getSessionData } from '@confluence/session-data/entry-points/SessionData.ts';

import type { AutomatedMeetingNotesPagePropertiesResult } from '../__types__/AutomatedMeetingNotesPagePropertiesResult.ts';

import type {
	useAutomatedMeetingNotesPagePropertiesQuery as getAutomatedMeetingNotesPagePropertiesQuery$data,
	useAutomatedMeetingNotesPagePropertiesQueryVariables as getAutomatedMeetingNotesPagePropertiesQuery$variables,
} from './__types__/useAutomatedMeetingNotesPagePropertiesQuery.ts';
import { extractAmnPageProperties } from './useAutomatedMeetingNotesPageProperties.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
const getAutomatedMeetingNotesPagePropertiesQuery = graphql`
	query getAutomatedMeetingNotesPagePropertiesQuery($pageAri: ID!) {
		page(id: $pageAri) {
			properties(keys: ["isAutomatedMeetingNotes", "meetingRecurrenceAri"]) {
				nodes {
					key
					value
				}
			}
			subType
			id
		}
	}
`;

export type getAmnPagePropertyQueryResult = Omit<
	AutomatedMeetingNotesPagePropertiesResult,
	'isLoading'
>;

export const getAutomatedMeetingNotesPageProperties = async (
	pageId: string,
): Promise<getAmnPagePropertyQueryResult> => {
	const { cloudId } = await getSessionData();
	const pageAri = ConfluencePageAri.create({
		siteId: cloudId,
		pageId,
	}).toString();

	// There is no non-hook alternative for getApolloClient AFAIK
	const { data } = await queryInterop<
		getAutomatedMeetingNotesPagePropertiesQuery$data,
		getAutomatedMeetingNotesPagePropertiesQuery$variables
	>({
		query: getAutomatedMeetingNotesPagePropertiesQuery,
		variables: { pageAri },
		errorPolicy: 'none',
	});

	return extractAmnPageProperties(data);
};
